import { apiClient } from './client'

export interface Notification {
  id: string
  type: string
  title: string
  message: string | null
  order_id: string | null
  order_number: string | null
  driver_id: string | null
  is_read: boolean
  created_at: string
  is_virtual: boolean
}

export interface NotificationListResponse {
  success: boolean
  data: Notification[]
  unread_count: number
}

export const getNotifications = async (unreadOnly = false): Promise<NotificationListResponse> => {
  const response = await apiClient.get<NotificationListResponse>('/notifications', {
    params: unreadOnly ? { unread_only: true } : {},
  })
  return response.data
}

export const getUnreadNotificationCount = async (): Promise<number> => {
  const response = await apiClient.get<{ unread_count: number }>('/notifications/unread-count')
  return response.data.unread_count
}

export const markNotificationRead = async (id: string): Promise<void> => {
  await apiClient.patch(`/notifications/${id}/read`)
}

export const markAllNotificationsRead = async (): Promise<void> => {
  await apiClient.post('/notifications/mark-all-read')
}
